import { useTranslation } from "react-i18next";
import LegalLayout from "@/components/LegalLayout";

const sections = [
  {
    id: "purpose",
    title: "Purpose & scope",
    body: [
      "Instantxfer CashApp is committed to preventing money laundering, terrorism financing and sanctions evasion. This policy summarises the framework we and our partners apply across every corridor.",
      "It applies to all customers, business accounts, employees and third-party processors involved in the flow of funds.",
    ],
  },
  {
    id: "framework",
    title: "Regulatory framework",
    body: [
      "We comply with FATF Recommendations, the EU 5th and 6th Anti-Money Laundering Directives, and equivalent local frameworks (UK MLR 2017, Nigeria's SCUML and CBN AML/CFT, Kenya's POCAMLA, South Africa's FICA, and others depending on the corridor).",
      "We partner exclusively with licensed money-service businesses (MSBs) in each jurisdiction.",
    ],
  },
  {
    id: "cdd",
    title: "Customer due diligence",
    body: [
      "We collect and verify identity information on every account — including a government-issued ID and a biometric liveness selfie.",
      "Business accounts are subject to enhanced due diligence, including beneficial-ownership verification, source of funds review, and industry-specific screening.",
      "PEP (politically exposed person) and adverse-media screening runs on onboarding and continuously.",
    ],
  },
  {
    id: "sanctions",
    title: "Sanctions screening",
    body: [
      "Every counterparty — sender, recipient, and intermediary — is screened in real time against UN, EU, UK OFSI, US OFAC and equivalent local lists prior to settlement.",
      "Hits are paused for human review; confirmed matches result in blocked transfers and, where required, regulatory disclosure.",
    ],
  },
  {
    id: "monitoring",
    title: "Transaction monitoring",
    body: [
      "Our ML-based monitoring engine scores every send on device signals, behavioural patterns and network heuristics. Alerts route to a 24/7 human review team.",
      "Suspicious activity is reported to the appropriate Financial Intelligence Unit (FinCEN, FIU-NL, NFIU, FRC, etc.) via our licensed partners.",
    ],
  },
  {
    id: "records",
    title: "Record-keeping",
    body: [
      "We retain KYC, transaction and monitoring records for a minimum of five years after account closure — or longer where required by local law.",
    ],
  },
  {
    id: "training",
    title: "Training & governance",
    body: [
      "All employees complete mandatory AML/CTF training on hire and annually. Our MLRO reports directly to the CEO and the Board Risk Committee.",
      "The policy is reviewed at least annually and after any material regulatory change.",
    ],
  },
  {
    id: "cooperation",
    title: "Cooperation with authorities",
    body: [
      "We respond promptly and fully to lawful requests from regulators, financial intelligence units and law enforcement in every jurisdiction we operate in.",
    ],
  },
];

export default function AMLKYC() {
  const { t } = useTranslation();
  return (
    <LegalLayout
      eyebrow={t("pageHero.aml.eyebrow")}
      title={t("pageHero.aml.title")}
      updated="December 2025"
      sections={sections}
      testId="amlkyc-page"
    />
  );
}
